import {
  aprovarRelatorioHomologacao,
  getAnexoRelatorioHomologacao,
  getRelatorioHomologacao,
  getTemplateRelatorioHomologacao,
  onRelatorioHomologacao,
  RelatorioHomologacaoProps,
} from '@app/api/sas/relatorioHomologacao';

import jsPDF from 'jspdf';
import logoPng from '@images/logotipo_mrn_verde.png';
import { UploadMultProps, Visibility } from '@app/components';
import { Button, FormatText, FormSubmitButton, MasterDetailForm, Widget } from '@digital/ui';
import { Collapse, Icon } from 'antd';
import html2canvas from 'html2canvas';
import React, { useEffect, useRef, useState } from 'react';
import FormAbaRelHomologacao from './FormAbaRelHomologacao';
import {
  desabilitarAcoesState,
  ordemCompraAbasState,
  ordemCompraIdState,
  reloadAbaStateState,
  reloadState,
} from '../atoms';
import { useRecoilState, useRecoilValue } from 'recoil';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';
import ModalReprovarRelatorioHomologacao from './ModalReprovarRelatorioHomologacao';
import { hasPermission } from '@app/helpers/permissions';
import ModalReenviarAprovacaoRelatorioHomologacao from './ModalReenviarAprovacaoRelatorioHomologacao';
import ModalHistorioAprovacoes from './ModalHistorioAprovacoes';
const { Panel } = Collapse;

interface Props {
  parteDoFluxo?: boolean;
  ehComprador: boolean;
}

const WidgetRelatorioHomologacao = ({ parteDoFluxo = false, ehComprador }: Props) => {
  const ordemCompraId = useRecoilValue(ordemCompraIdState);
  const desabilitarAcoes = useRecoilValue(desabilitarAcoesState);
  const [reload, setReload] = useRecoilState(reloadState);
  const [reloadAba, setReloadAba] = useRecoilState(reloadAbaStateState);

  const [dadosRelatorio, setDadosRelatorio] = useState<RelatorioHomologacaoProps>();
  const [nomeArquivo, setNomeArquivo] = useState<string | undefined>(undefined);
  const [idArquivo, setIdArquivo] = useState<string | undefined>(undefined);
  const [data, setData] = useState<any[]>([]);
  const [reloadRelatorio, setReloadRelatorio] = useState<boolean>(false);
  const [url, setURL] = useState(window.location.href);
const refRelatorioContent = useRef<HTMLDivElement>(null);

  const onReloadRelatorio = () => {
    setReloadRelatorio(!reloadRelatorio);
    setReloadAba(!reloadAba);
  };

  if (window.location.href != url) {
    setURL(window.location.href);
    if (window.location.href.toLocaleLowerCase().includes('relhomologacao')) onReloadRelatorio();
    if (window.location.href.toLocaleLowerCase().includes('fluxoprocesso')) onReloadRelatorio();
  }

  const getInfoRelatorio = (ocId: string) => {
    getRelatorioHomologacao(ocId).then(data => {
      if (data) {
        setDadosRelatorio(data);
        if (data.anexoNome) {
          setIdArquivo(data.anexoId);
          setNomeArquivo(data.anexoNome);
        }
      }
    });
  };

  useEffect(() => {
    if (ordemCompraId) {
      getInfoRelatorio(ordemCompraId);
    }
  }, [ordemCompraId, reload, reloadRelatorio]);

  const exportFile = async () => {
    await getTemplateRelatorioHomologacao(ordemCompraId);
  };

  const exportPdf = async () => {
    if (!refRelatorioContent.current) return;

    // Captura o conteúdo em scale menor para reduzir tamanho final
    const canvas = await html2canvas(refRelatorioContent.current, { scale: 1.2, useCORS: true });
    const imgData = canvas.toDataURL('image/jpeg', 0.75);

    // Redimensiona e comprime a logo num canvas pequeno antes de embarcar no PDF
    const logoUrl = URL.createObjectURL(await fetch(logoPng).then(r => r.blob()));
    const logoBase64 = await new Promise<string>(resolve => {
      const img = new Image();
      img.onload = () => {
        const offscreen = document.createElement('canvas');
        offscreen.width = 140;
        offscreen.height = 48;
        const ctx = offscreen.getContext('2d')!;
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, offscreen.width, offscreen.height);
        ctx.drawImage(img, 0, 0, offscreen.width, offscreen.height);
        URL.revokeObjectURL(logoUrl);
        resolve(offscreen.toDataURL('image/jpeg', 0.8));
      };
      img.src = logoUrl;
    });

    const pdf = new jsPDF({ orientation: 'landscape', format: 'a4', unit: 'mm' });
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const headerHeight = 16;
    const contentAreaHeight = pageHeight - headerHeight;
    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let pageIndex = 0;

    while (heightLeft > 0) {
      if (pageIndex > 0) pdf.addPage();

      pdf.addImage(logoBase64, 'JPEG', 3, 2, 35, 12);
      pdf.setFontSize(11);
      pdf.setFont('helvetica', 'bold');
      pdf.text('RELATÓRIO DE HOMOLOGAÇÃO', pageWidth / 2, 10, { align: 'center' });
      pdf.setLineWidth(0.3);
      pdf.line(0, headerHeight, pageWidth, headerHeight);

      pdf.addImage(imgData, 'JPEG', 0, headerHeight - pageIndex * contentAreaHeight, imgWidth, imgHeight);
      heightLeft -= contentAreaHeight;
      pageIndex++;
    }

    pdf.save('Relatório de Homologação.pdf');
  };


  const downloadFile = async () => {
    await getAnexoRelatorioHomologacao(idArquivo!, nomeArquivo!);
  };

  const fileUpload = (e: any) => {
    setNomeArquivo(e.file.fileName);
    setIdArquivo(e.id);
  };

  const updateValues = async (values: any) => {
    if (data.length > 0) {
      values.valorAditivo = data[data.length - 1].valorAditivo;
      values.terminoVigenciaAditivo = data[data.length - 1].terminoVigencia;
    }
    if (!dadosRelatorio) {
      return;
    }
    await onRelatorioHomologacao(ordemCompraId, {
      ...values,
      condicoesComerciais: dadosRelatorio.tipoOc === 2 ? data : [],
    });

    onReloadRelatorio();
  };

  const handleAprovarRelatorio = () => {
    aprovarRelatorioHomologacao(ordemCompraId, '').then(data => {
      if (data && data.valid) {
        onReloadRelatorio();
      }
    });
  };
  const podeSalvarBase = !parteDoFluxo && ehComprador && desabilitarAcoes === false;

  const isFaturamentoDireto = dadosRelatorio && (dadosRelatorio.tipoOc === ETipoDemanda.FaturamentoDireto || dadosRelatorio.tipoOc === ETipoDemanda.AditivoFaturamentoDireto);

  const isHomologadoSuccess =
    dadosRelatorio &&
    dadosRelatorio.aprovacaoGerenteAquisicoesStatus === 'Aprovado' &&
    dadosRelatorio.aprovacaoGerenteGeralStatus === 'Aprovado';

  const deveExibirSalvar = podeSalvarBase && (isFaturamentoDireto ? !isHomologadoSuccess : true);
  return (
    <>
      {dadosRelatorio && (
        <Collapse
          bordered={false}
          defaultActiveKey="AbaRelatorioHomologacao"
          expandIcon={() => <Icon type="arrows-right_4" />}>
          <Panel
            key="AbaRelatorioHomologacao"
            header={`Relatório de Homologação - ${
              dadosRelatorio && (dadosRelatorio.tipoOc === ETipoDemanda.NovaContratacao
                ? 'Nova Contratação'
                : dadosRelatorio.tipoOc === ETipoDemanda.FaturamentoDireto
                ? 'Faturamento Direto'
                : 'Aditivo') || 'Carregando...'
            }`}
            showArrow={!parteDoFluxo}>
            <Widget className="aba-rel-homologacao">
              <MasterDetailForm
                actions={[
                  <Visibility
                    visible={
                      ['Pendente', 'Em Revisão'].includes(dadosRelatorio.aprovacaoGerenteAquisicoesStatus) &&
                      hasPermission(['SAS_APROVAR_RELATORIO_HOMOLOGACAO_GERENTE_AQUISICAO']) &&
                      !parteDoFluxo
                    }>
                    <Button
                      style={{ marginRight: 10 }}
                      onClick={handleAprovarRelatorio}
                      title="Aprovar"
                      type="primary"
                    />
                  </Visibility>,

                  <Visibility
                    visible={
                      !['Pendente', 'Em Revisão'].includes(dadosRelatorio.aprovacaoGerenteAquisicoesStatus) &&
                      ['Pendente', 'Em Revisão'].includes(dadosRelatorio.aprovacaoGerenteGeralStatus) &&
                      hasPermission(['SAS_APROVAR_RELATORIO_HOMOLOGACAO_GERENTE_GERAL']) &&
                      !parteDoFluxo
                    }>
                    <Button
                      style={{ marginRight: 10 }}
                      onClick={handleAprovarRelatorio}
                      title="Aprovar"
                      type="primary"
                    />
                  </Visibility>,

                  <Visibility
                    visible={
                      ['Pendente', 'Em Revisão'].includes(dadosRelatorio.aprovacaoGerenteAquisicoesStatus) &&
                      ['Em Revisão'].includes(dadosRelatorio.aprovacaoGerenteGeralStatus) &&
                      hasPermission(['SAS_APROVAR_RELATORIO_HOMOLOGACAO_GERENTE_AQUISICAO']) &&
                      !parteDoFluxo
                    }>
                    <ModalReenviarAprovacaoRelatorioHomologacao onReloadRelatorio={onReloadRelatorio} />
                  </Visibility>,

                  <Visibility
                    visible={
                      (['Em Revisão', 'Pendente'].includes(dadosRelatorio.aprovacaoGerenteGeralStatus) &&
                        hasPermission(['SAS_APROVAR_RELATORIO_HOMOLOGACAO_GERENTE_GERAL'])) ||
                      (['Em Revisão', 'Pendente'].includes(dadosRelatorio.aprovacaoGerenteAquisicoesStatus) &&
                        hasPermission(['SAS_APROVAR_RELATORIO_HOMOLOGACAO_GERENTE_AQUISICAO']) &&
                        !parteDoFluxo)
                    }>
                    <ModalReprovarRelatorioHomologacao onReloadRelatorio={onReloadRelatorio} />
                  </Visibility>,

                  <Visibility visible={parteDoFluxo}>
                    <ModalHistorioAprovacoes />
                  </Visibility>,

                  <>
                    {idArquivo && !parteDoFluxo && (
                      <Button style={{ marginRight: 10 }} type="primary" onClick={downloadFile}>
                        <FormatText id="DOWNLOAD" />
                      </Button>
                    )}
                  </>,
                  <UploadMultProps
                    visible={!parteDoFluxo && ehComprador && desabilitarAcoes === false}
                    idDoComponente="mrn-button-AbaRelHomologacao-upload-incluir"
                    tooltip={'Incluir Arquivo'}
                    listUploadPropsForm={
                      idArquivo
                        ? [
                            { key: 'ordemCompraId', value: ordemCompraId },
                            { key: 'id', value: idArquivo },
                          ]
                        : [{ key: 'ordemCompraId', value: ordemCompraId }]
                    }
                    enderecoApi={`rhSas/anexo`}
                    iconName={'ui-upload'}
                    hasFile={false}
                    label={idArquivo ? 'ATUALIZAR ANEXO' : 'INCLUIR ANEXO'}
                    buttonClass="ant-btn-primary"
                    retorno={e => fileUpload(e)}
                  />,
                  <Visibility visible={!parteDoFluxo && ehComprador}>
                    <Button style={{ marginLeft: 10 }} type="primary" onClick={exportFile}>
                      <FormatText id="EXPORTAR" />
                    </Button>
                  </Visibility>,
                  <Visibility visible={!parteDoFluxo && ehComprador}>
                    <Button style={{ marginLeft: 10 }} type="primary" onClick={exportPdf}>
                      EXPORTAR PDF
                    </Button>
                  </Visibility>,

                  <>
                    {deveExibirSalvar && (
                      <FormSubmitButton
                        style={{ marginLeft: 10 }}
                        type="primary"
                        noIcon
                        onClick={item => updateValues(item)}>
                        <FormatText id="SALVAR" />
                      </FormSubmitButton>
                    )}
                  </>,
                ]}>
                {dadosRelatorio &&
                (dadosRelatorio.nomePropostaPremiada || dadosRelatorio.tipoOc == ETipoDemanda.Aditivo) ? (
                  <FormAbaRelHomologacao
                    ref={refRelatorioContent}
                    dadosRelatorio={dadosRelatorio}
                    setNewDate={setData}
                    parteDoFluxo={parteDoFluxo}
                    ehComprador={ehComprador}
                  />
                ) : (
                  'O vencedor ainda não foi definido na Aba Dados Gerais'
                )}
              </MasterDetailForm>
            </Widget>
          </Panel>
        </Collapse>
      )}
    </>
  );
};
export default WidgetRelatorioHomologacao;
